import { ZoomIn, ZoomOut } from '@mui/icons-material';
import { Grid, Box, Typography, IconButton } from '@mui/material';
import { Dispatch, MutableRefObject, SetStateAction } from 'react';
import { CanvasRef } from 'reaflow';
import { useSystemModules } from '../systemModules/api/getSystemModules';
import {
  satelliteNodeBackground,
  dishNodeBackground,
  locationNodeBackground,
  switchNodeBackground,
  switchNodeDisabledBackground,
  analyzerNodeBackground,
} from './utils/theming';

interface Props {
  backgroundColor: string;
}

const LegendBox = ({ backgroundColor }: Props) => {
  return (
    <Box
      sx={{
        backgroundColor: backgroundColor,
        height: 15,
        width: 15,
        borderRadius: 0.3,
        marginRight: '.2rem',
      }}
    ></Box>
  );
};

interface PageProps {
  canvasRef: CanvasRef | null;
  zoomFactor: number;
  setZoomFactor: Dispatch<SetStateAction<number>>;
  legendRef: MutableRefObject<any>;
}

const SystemOverviewLegend = ({
  canvasRef,
  zoomFactor,
  setZoomFactor,
  legendRef,
}: PageProps) => {
  const { data: modules } = useSystemModules({});
  return (
    <Grid container item justifyContent='space-between' ref={legendRef}>
      <Grid
        justifyContent='flex-start'
        item
        xs
        container
        alignItems={'center'}
        sx={{ mt: '.8rem' }}
      >
        <Grid
          item
          container
          xs={1}
          alignItems='center'
          style={{ minWidth: '6rem' }}
        >
          <LegendBox backgroundColor={satelliteNodeBackground} />
          <Typography>Satellites</Typography>
        </Grid>
        <Grid
          item
          container
          xs={1}
          alignItems='center'
          style={{ minWidth: '6rem' }}
        >
          <LegendBox backgroundColor={dishNodeBackground} />
          <Typography>Dishes</Typography>
        </Grid>
        <Grid
          item
          container
          xs={1}
          alignItems='center'
          style={{ minWidth: '6rem' }}
        >
          <LegendBox backgroundColor={locationNodeBackground} />
          <Typography>Locations</Typography>
        </Grid>
        {modules?.SWITCHES && (
          <>
            <Grid
              item
              container
              xs={1}
              alignItems='center'
              style={{ minWidth: '6rem' }}
            >
              <LegendBox backgroundColor={switchNodeBackground} />
              <Typography>Switches</Typography>
            </Grid>
            <Grid
              item
              container
              xs={1}
              alignItems='center'
              style={{ minWidth: '10.5rem' }}
            >
              <LegendBox backgroundColor={switchNodeDisabledBackground} />
              <Typography>Switches (Disabled)</Typography>
            </Grid>
          </>
        )}
        <Grid
          item
          container
          xs={1}
          alignItems='center'
          style={{ minWidth: '6rem' }}
        >
          <LegendBox backgroundColor={analyzerNodeBackground} />
          <Typography>Analyzers</Typography>
        </Grid>
      </Grid>
      <Grid item>
        <IconButton
          onClick={() => {
            if (canvasRef && canvasRef.setZoom)
              canvasRef.setZoom(zoomFactor + 0.2);
            setZoomFactor((state) => state + 0.2);
          }}
          disabled={zoomFactor >= 1 - 0.08}
        >
          <ZoomIn />
        </IconButton>
        <IconButton
          onClick={() => {
            if (canvasRef && canvasRef.setZoom)
              canvasRef.setZoom(zoomFactor - 0.2);
            setZoomFactor((state) => state - 0.2);
          }}
          disabled={zoomFactor <= -0.5 + 0.08}
        >
          <ZoomOut />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default SystemOverviewLegend;
